import { render, staticRenderFns } from "./ClickRejectionModal.vue?vue&type=template&id=0f5a024b&scoped=true"
import script from "./ClickRejectionModal.vue?vue&type=script&lang=ts"
export * from "./ClickRejectionModal.vue?vue&type=script&lang=ts"
import style0 from "./ClickRejectionModal.vue?vue&type=style&index=0&id=0f5a024b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5a024b",
  null
  
)

export default component.exports